export type Duration = {
  years?: number;
  months?: number;
  weeks?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
};

export type PrecisionTypes =
  | 'month'
  | 'week'
  | 'day'
  | 'calendarDay'
  | 'hour'
  | 'minute'
  | 'second'
  | 'millisecond';

export enum DateFormat {
  Date = 'dd-MM-yyyy', // 17-07-2025
  DateReverse = 'yyyy-MM-dd', // 2025-07-17
  ShortMonthAndYear = 'MMM yyyy', // Jul 2025
  DateWithShortMonth = 'd MMM yyyy', // 17 Jul 2025
  DateWithFullMonth = 'd MMMM yyyy', // 17 July 2025
  DateWithFullMonthComma = 'd MMMM, yyyy', // 17 July, 2025
  Time = 'HH:mm', // 14:45
  Day = 'd', // 17
  DateMonth = 'd MMM', // 17 Jul
  DateFullMonthName = 'd MMMM', // 17 July
  MonthShortName = 'MMM', // Jul
  DateMonthWithDot = 'd. MMM', // 17. Jul
  DateTime = 'd MMM, HH:mm', // 17 Jul, 14:45
  FullDateTime = 'dd-MM-yyyy HH:mm', // 17-07-2025 14:45
  FullDayName = 'EEEE', // Thursday
  ShortDayName = 'EEEEEE', // Th
  MonthFullName = 'LLLL', // July
  FullYear = 'yyyy', // 2025
  CnxFormat = 'yyyy-MM-dd HH:mm', // 2025-07-17 14:45
  ISO = "yyyy-MM-dd'T'HH:mm:ss", // 2025-07-17T14:45:00
  DayAndShortDate = 'eee, d', // Thu, 17
  DayShortMonthShortYear = 'eee, d MMM yyyy', // Thu, 17 Jul 2025
  DayShortMonthShort = 'eee, d MMM', // Thu, 17 Jul
  FullMonthAndYear = 'MMMM, yyyy', // July, 2025
  DayShortMonthShortNoComma = 'eee d MMM', // Thu 17 Jul
}

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export type MonthIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
